import { Vue, Component, Prop } from 'vue-property-decorator';
import MasteryCompetencyCompletionSetting from '../mastry-competency-completion-setting/mastery-competency-completion-setting';

@Component({
    name: 'default-view-fw-level',
    components: {
        'mastery-competency-completion-setting': MasteryCompetencyCompletionSetting,
    },
})

export default class DefaultViewFwLevel extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    private defaultText: any = '';

    @Prop()
    private contentLoader: any;

    @Prop()
    private tenantSettings: any;

    private defaultMinScore: any = '0';

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.defaultText = tenantSettings.value;
        }
    }

    // ------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        this.$emit('onChangeConfig', this.defaultText);
    }
}
